import { useSelector } from 'react-redux'

import { selectMe } from '@/redux/me/meSlice'
import { mixpanel } from '@/utils/analytics'

interface UseTailgateMixpanelEventsIProps {
  facilityId: string
  floorId: string
  cameraId: string
  doorId: string
}

export const useTailgateMixpanelEvents = ({
  facilityId,
  floorId,
  cameraId,
  doorId,
}: UseTailgateMixpanelEventsIProps) => {
  const me = useSelector(selectMe)
  const trackTailgateEvent = (name: string) => {
    mixpanel.track(name, {
      facility_id: facilityId,
      floor_id: floorId,
      camera_id: cameraId,
      door_id: doorId,
      role: me.roleName,
    })
  }

  return {
    trackTailgateEvent,
  }
}
